import request from '@/utils/request'

let ProcessApi = {
  //健康证列表
  HealthList(data, errorback) {
    return request._post('/shop/waiter.Health/index', data, errorback);
  },
  //健康证删除
  HealthDel(data, errorback) {
    return request._post('/shop/waiter.Health/del', data, errorback);
  },
  //健康证审核
  HealthExamine(data, errorback) {
    return request._post('/shop/waiter.Health/examine', data, errorback);
  },

  // 无犯罪列表
  NoCrimeList(data, errorback) {
    return request._post('/shop/waiter.NoCrime/index', data, errorback);
  },
  // 无犯罪删除
  NoCrimeDel(data, errorback) {
    return request._post('/shop/waiter.NoCrime/del', data, errorback);
  },
  // 无犯罪审核
  NoCrimeExamine(data, errorback) {
    return request._post('/shop/waiter.NoCrime/examine', data, errorback);
  },
  //资质列表
  AptitudeList(data, errorback) {
    return request._post('/shop/waiter.Aptitude/index', data, errorback);
  },
  //资质删除
  AptitudeDel(data, errorback) {
    return request._post('/shop/waiter.Aptitude/del', data, errorback);
  },
  //资质审核
  AptitudeExamine(data, errorback) {
    return request._post('/shop/waiter.Aptitude/examine', data, errorback);
  },
  //实名认证审核
  authExamine(data, errorback) {
    return request._post('/shop/waiter.auth/examine', data, errorback);
  },
  // 实名认证列表
  authList(data, errorback) {
    return request._post('/shop/waiter.auth/index', data, errorback);
  },
  //实名认证删除
  authDel(data, errorback) {
    return request._post('/shop/waiter.auth/del', data, errorback);
  },
  //技师审核
  technicianEntry(data, errorback) {
    return request._post('/shop/Technician/getTechnician', data, errorback);
  },
  // 技师申请通过
  adopt(data, errorback) {
    return request._post('/shop/Technician/adopt', data, errorback);
  },
  // 拒绝技师申请
  refuse(data, errorback) {
    return request._post('/shop/Technician/refuse', data, errorback);
  },
  // 营业执照列表
  LicenceList(data, errorback) {
    return request._post('/shop/waiter.Licence/index', data, errorback);
  },
  //营业执照删除
  LicenceDel(data, errorback) {
    return request._post('/shop/waiter.Licence/del', data, errorback);
  },
  //营业执照审核
  LicenceExamine(data, errorback) {
    return request._post('/shop/waiter.Licence/examine', data, errorback);
  },
  /*技师评价审核*/
  replyComment(data, errorback) {
    return request._post('/shop/waiter.Comment/replyComment', data, errorback);
  },
  /*技师评价列表*/
  commentStatusList(data, errorback) {
    return request._get('/shop/waiter.Comment/commentStatusList', data, errorback);
  },
  /*技师评价删除*/
  commentsetDelete(data, errorback) {
    return request._get('/shop/waiter.Comment/setDelete', data, errorback);
  },
  // 签署协议列表
  protocollist(data, errorback) {
    return request._post('/shop/waiter.Contract/index', data, errorback);
  },
  // 签署协议删除
  protocolDel(data, errorback) {
    return request._post('/shop/waiter.Contract/del', data, errorback);
  },
  //签署协议审核
  protocolExamine(data, errorback) {
    return request._post('/shop/waiter.Contract/examine', data, errorback);
  },

}
export default ProcessApi;



// WEBPACK FOOTER //
// ./src/api/process.js